import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the accounts and factoring api
 */
export class PostalCodeService extends BaseService {

	constructor() {	
		super();
	}
	
	async getPostalCodes(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/postal-code-cities' + params);		
		return data;		
	}

	exportPostalCodes(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/postal-code-cities/export' + params);
	}
	
	async getPostalCode(postalCodeCityId) {
		var data = await this.makeGETRequest('/api/resource/postal-code-cities/' + 
				encodeURIComponent(postalCodeCityId.countryCode) + '/' +
				encodeURIComponent(postalCodeCityId.stateProvCode) + '/' +
				encodeURIComponent(postalCodeCityId.cityName) + '/' +
				encodeURIComponent(postalCodeCityId.postalCode)
		);		
		return data;		
	}
	
	async savePostalCode(postalcodeCity, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/postal-code-cities/' + 
				encodeURIComponent(postalcodeCity.postalCodeCityId.countryCode) + '/' +
				encodeURIComponent(postalcodeCity.postalCodeCityId.stateProvCode) + '/' +
				encodeURIComponent(postalcodeCity.postalCodeCityId.cityName) + '/' +
				encodeURIComponent(postalcodeCity.postalCodeCityId.postalCode), postalcodeCity
			);
		} else {
			saved = await this.makePOSTRequest('/api/resource/postal-code-cities', postalcodeCity);
		}
		return saved;		
	}	
	
	async deletePostalCode(postalCodeCityId) {
		var data = await this.makeDELETERequest('/api/resource/postal-code-cities/' + 
				encodeURIComponent(postalCodeCityId.countryCode) + '/' +
				encodeURIComponent(postalCodeCityId.stateProvCode) + '/' +
				encodeURIComponent(postalCodeCityId.cityName) + '/' +
				encodeURIComponent(postalCodeCityId.postalCode)
		);		
		return data;		
	}
	
}
